import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Switch, Button
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";



export default function UserTable({ users, onStatusToggle }) {
  const navigate = useNavigate();
  return (
    <TableContainer component={Paper} sx={{
      borderRadius: 3,
      maxHeight: "80vh",      //controls height
      overflowY: "auto",      //enables vertical scroll
    }}>
      <Table>
        <TableHead sx={{ backgroundColor: "#d7ebfa" }}>
          <TableRow>
            {/* <TableCell><b>User ID</b></TableCell> */}
            <TableCell><b>Username</b></TableCell>
            <TableCell><b>First Name</b></TableCell>
            <TableCell><b>Last Name</b></TableCell>
            <TableCell><b>Email</b></TableCell>
            <TableCell><b>Status</b></TableCell>
            <TableCell><b>Action</b></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {users.map((user, index) => (
            <TableRow key={user.id}>
              {/* <TableCell disabled>{user.id}</TableCell> */}
              <TableCell>{user.username}</TableCell>
              <TableCell>{user.firstName}</TableCell>
              <TableCell>{user.lastName}</TableCell>
              <TableCell>{user.email}</TableCell>
              {/* <TableCell>
                {user.active ? "Active" : "Inactive"}
              </TableCell> */}
              <TableCell>
                <Switch
                  checked={user.enabled}   // Keycloak uses `enabled`
                  color="success"
                  // onChange={() => handleToggle(user)}
                  onChange={() => onStatusToggle(user)}


                />
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<VisibilityIcon />}
                  sx={{ backgroundColor: "#e76f51" }}
                  onClick={() => navigate(`/users/view/${user.id}`)}
                >
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
